import { Link } from "react-router-dom";
export default function ErrorComponentCallback({ error, resetErrorBoundary }) {
  // console.log(error)
  return (
    <div className="section section-not-found mt-2">
      <div className="section-body">
        <h2
          style={{
            color: "orange",
          }}
        >
          Something went wrong:
        </h2>
        {process.env.NODE_ENV !== "production" && <p>{error.message}</p>}
        <p>
          You can go back to our
          <Link to="/home" style={{ textDecoration: "none" }}>
            {" "}
            Homepage.
          </Link>
        </p>
      </div>
    </div>
  );
}
